// Sound utilities using Web Audio API and Audio elements

export const playCorrectSound = () => {
  try {
    const audio = new Audio('data:audio/wav;base64,UklGRnoGAABXQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YQoGAACBhYqFbF1fdJivrJBhNjVgodDbq2EcBj+a2/LDciUFLIHO8tiJNwgZaLvt559NEAxQp+PwtmMcBjiR1/LMeSwFJHfH8N2QQAoUXrTp66hVFApGn+DyvmwhBjKJ0fPTgjMGHm7A7+OZXQ8OWKvn56pdGwxTquPyuVkUC0yj4/K4bRwMS6Xk8r1wHQxPp+Xxvm4eCFKq5fHBcRoLUKjl8L90HwxRp+Xxw3EcC1Co5fHEdRwNUKfl8cZzHQxRqOXxw3EcC1Cn5PHCcBwLUKjk8cJwGwtRp+Txw3EcC0+n5PLCbxwLT6jk8sNyGwtQqOTywm8cC1Go5PHBcxwLT6fk8sFuGwtQqOTxwXEcC0+n5PLBbxwMT6fk8cFwHAxQp+TxwG8dDFGn5PHBcBwMUafk8cJxGwxRp+TxwXEcDFGn5PHCcBwMUKfk8cJyHAxRp+TxwXAcDFGn5PHBcxwMUafk8cJyHAxRp+Txw3EcDFGn5PHCcBwMUafj8cJyHAxRqOPxxHEcDFGo4/HBcBwLUKfk8cJxGwtQp+TxwnEcC0+n5PHCcBwLUKjj8cBwGwtQqOTxwXAcC0+n5PHBbxwLUKjk8cJwGwtRp+TxwnAcC1Cn5PHCcBwMUafk8cFvGwtRqOTxwnAbDFGn5PHBcRwLUKfk8cFyGwtRp+TxwXEcC1Cn5PHBcBwLUKjk8cFyGwtRp+Txw3AcC1Cn5PHBcBwLUafk8cJxHAtRp+TxwXEcC1Gn5PHBcBwLUafk8cJwGwtRp+TxwXEcC1Gn5PHCcRwLUafk8cJwHAtRp+TxwnEcC1Gn5PHCcRwMUafk8cJxHAtQp+TxwnEcC1Gn5PHCcRwLUafk8cJxHAtRp+TxwnEcC1Gn5PHCcRwLUafk8cJxHAtRp+TxwnEcC1Gn5PHCcRwLUafk8cJxGwtRp+TxwnEcC1Gn5PHCcRwLUafk8cJxGwtRp+TxwnEcC1Gn5PHCcRwLUafk8cJxGwtRp+TxwnEcC1Gn5PHCcRwLUafk8cJxGwtRp+TxwnEcC1Gn5PHCcRwLUafk8cJxGwtRp+TxwnEcC1Gn5PHCcRwLUafk8cJxGwtRp+TxwnEcC1Gn5PHCcRwLUKfk8cJxGwtRp+TxwnEcC1Gn5PHCcRwLUafk8cJxGwtRp+TxwnEcC1Gn5PHCcRwLUafk8cJxGwtRp+TxwnEcC1Gn5PHCcRwLUafk8cJxGwtRp+TxwnEcC1Gn5PHCcRwLUafk8cJxGwtRp+TxwnEcC1Gn5PHCcRwLUafk8cJxGwtRp+TxwnEcC1Gn5PHCcRwLUafk8cJxGwtRp+TxwnEcC1Gn5PHCcRwLUafk8cJxGwtRp+TxwnEcC1Gn5PHCcRwLUafk8cJxGwtRp+TxwnEcC1Gn5PHCcRwLUafk8cJxGwtRp+TxwnEcC1Gn5PHCcRwLUafk8cJxGwtRp+TxwnEcC1Gn5PHCcRwLUafk8cJxGwtRp+TxwnEcC1Gn5PHCcRwLUafk8cJxGwtRp+TxwnEcC1Gn5PHCcRwLUafk8cJxGwtRp+TxwnEcC1Gn5PHCcRwLUafk8cJxGwtRp+TxwnAbC1Gn5PHCcRsLUafk8cJxGwtRp+TxwnEcC1Gn5PHCcRwLUafk8cJxGwtRp+TxwnEcC1Gn5PHCcRwLUafk8cJxGwtRp+TxwnEcC1Gn5PHCcRwLUafk8cJxGwtRp+TxwnEcC1Gn5PHCcRwLUafk8cJxGwtRp+TxwnEcC1Gn5PHCcRwLUafk8cJxGwtRp+TxwnEcC1Gn5PHCcRwLUafk8cJxGwtRp+TxwnEcC1Gn5PHCcRwLUafk8cJxGwtRp+TxwnEcC1Gn5PHCcRwLUafk8cJxGwtRp+TxwnEcC1Gn5PHCcRwLUafk8cJxGwtRp+TxwnEcC1Gn5PHCcRwLUafk8cJxGwtRp+TxwnEcC1Gn5A==');
    audio.volume = 0.3;
    audio.play();
  } catch (error) {
    console.log('Error playing correct sound:', error);
  }
};

export const playIncorrectSound = () => {
  try {
    const audio = new Audio('data:audio/wav;base64,UklGRnoGAABXQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YQoGAACAhYqFbF1fdJivrJBhNjVgodDbq2EcBj+a2/LDciUFLIHO8tiJNwgZaLvt559NEAxQp+PwtmMcBjiR1/LMeSwFJHfH8N2QQAoUXrTp66hVFApGn+DyvmwhBjKJ0fPTgjMGHm7A7+OZXQ8OWKvn56pdGwxTquPyuVkUC0yj4/K4bRwMS6Xk8r1wHQxPp+Xxvm4eCFKq5fHBcRoLUKjl8L90HwxRp+Xxw3EcC1Co5fHEdRwNUKfl8cZzHQxRqOXxw3EcC1Cn5PHCcBwLUKjk8cJwGwtRp+Txw3EcC0+n5PLCbxwLT6jk8sNyGwtQqOTywm8cC1Go5PHBcxwLT6fk8sFuGwtQqOTxwXEcC0+n5PLBbxwMT6fk8cFwHAxQp+TxwG8dDFGn5PHBcBwMUafk8cJxGwxRp+TxwXEcDFGn5PHCcBwMUKfk8cJyHAxRp+TxwXAcDFGn5PHBcxwMUafk8cJyHAxRp+Txw3EcDFGn5PHCcBwMUafj8cJyHAxRqOPxxHEcDFGo4/HBcBwLUKfk8cJxGwtQp+TxwnEcC0+n5PHCcBwLUKjj8cBwGwtQqOTxwXAcC0+n5PHBbxwLUKjk8cJwGwtRp+TxwnAcC1Cn5PHCcBwMUafk8cFvGwtRqOTxwnAbDFGn5PHBcRwLUKfk8cFyGwtRp+TxwXEcC1Cn5PHBcBwLUKjk8cFyGwtRp+Txw3AcC1Cn5PHBcBwLUafk8cJxHAtRp+TxwXEcC1Gn5PHBcBwLUafk8cJwGwtRp+TxwXEcC1Gn5PHCcRwLUafk8cJwHAtRp+TxwnEcC1Gn5PHCcRwMUafk8cJxHAtQp+TxwnEcC1Gn5PHCcRwLUafk8cJxHAtRp+TxwnEcC1Gn5PHCcRwLUafk8cJxHAtRp+TxwnEcC1Gn5PHCcRwLUafk8cJxGwtRp+TxwnEcC1Gn5PHCcRwLUafk8cJxGwtRp+TxwnEcC1Gn5PHCcRwLUafk8cJxGwtRp+TxwnEcC1Gn5PHCcRwLUafk8cJxGwtRp+TxwnEcC1Gn5PHCcRwLUafk8cJxGwtRp+TxwnEcC1Gn5PHCcRwLUKfk8cJxGwtRp+TxwnEcC1Gn5PHCcRwLUafk8cJxGwtRp+TxwnEcC1Gn5PHCcRwLUafk8cJxGwtRp+TxwnEcC1Gn5PHCcRwLUafk8cJxGwtRp+TxwnEcC1Gn5PHCcRwLUafk8cJxGwtRp+TxwnEcC1Gn5PHCcRwLUafk8cJxGwtRp+TxwnEcC1Gn5PHCcRwLUafk8cJxGwtRp+TxwnEcC1Gn5PHCcRwLUafk8cJxGwtRp+TxwnEcC1Gn5PHCcRwLUafk8cJxGwtRp+TxwnEcC1Gn5PHCcRwLUafk8cJxGwtRp+TxwnEcC1Gn5PHCcRwLUafk8cJxGwtRp+TxwnEcC1Gn5PHCcRwLUafk8cJxGwtRp+TxwnAbC1Gn5PHCcRsLUafk8cJxGwtRp+TxwnEcC1Gn5PHCcRwLUafk8cJxGwtRp+TxwnEcC1Gn5PHCcRwLUafk8cJxGwtRp+TxwnEcC1Gn5PHCcRwLUafk8cJxGwtRp+TxwnEcC1Gn5PHCcRwLUafk8cJxGwtRp+TxwnEcC1Gn5PHCcRwLUafk8cJxGwtRp+TxwnEcC1Gn5PHCcRwLUafk8cJxGwtRp+TxwnEcC1Gn5PHCcRwLUafk8cJxGwtRp+TxwnEcC1Gn5PHCcRwLUafk8cJxGwtRp+TxwnEcC1Gn5PHCcRwLUafk8cJxGwtRp+TxwnEcC1Gn5PHCcRwLUafk8cJxGwtRp+TxwnEcC1Gn5A==');
    audio.volume = 0.3;
    audio.play();
  } catch (error) {
    console.log('Error playing incorrect sound:', error);
  }
};

export const playAchievementSound = () => {
  try {
    // Create a more pleasant achievement sound using Web Audio API
    const audioContext = new (window.AudioContext || window.webkitAudioContext)();
    
    const playTone = (frequency, startTime, duration) => {
      const oscillator = audioContext.createOscillator();
      const gainNode = audioContext.createGain();
      
      oscillator.connect(gainNode);
      gainNode.connect(audioContext.destination);
      
      oscillator.frequency.value = frequency;
      oscillator.type = 'sine';
      
      gainNode.gain.setValueAtTime(0.3, startTime);
      gainNode.gain.exponentialRampToValueAtTime(0.01, startTime + duration);
      
      oscillator.start(startTime);
      oscillator.stop(startTime + duration);
    };
    
    const now = audioContext.currentTime;
    playTone(523.25, now, 0.15);        // C5
    playTone(659.25, now + 0.15, 0.15); // E5
    playTone(783.99, now + 0.3, 0.3);   // G5
    
  } catch (error) {
    console.log('Error playing achievement sound:', error);
  }
};

export const playClickSound = () => {
  try {
    const audioContext = new (window.AudioContext || window.webkitAudioContext)();
    const oscillator = audioContext.createOscillator();
    const gainNode = audioContext.createGain();
    
    oscillator.connect(gainNode);
    gainNode.connect(audioContext.destination);
    
    oscillator.frequency.value = 800;
    oscillator.type = 'sine';
    
    const now = audioContext.currentTime;
    gainNode.gain.setValueAtTime(0.1, now);
    gainNode.gain.exponentialRampToValueAtTime(0.01, now + 0.05);
    
    oscillator.start(now);
    oscillator.stop(now + 0.05);
  } catch (error) {
    console.log('Error playing click sound:', error);
  }
};
